var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m24.9938108 25v-.0010349h.0061892v-9.1095824c0-4.4564715-.9562246-7.8893827-6.1489266-7.8893827-2.4962929 0-4.1714912 1.37440643-4.8553929 2.6774017h-.0722068v-2.26135397h-4.9234737v16.58291737h5.1266843v-8.2112505c0-2.1619993.4084843-4.2525874 3.0770421-4.2525874 2.6293598 0 2.6685578 2.467308 2.6685578 4.39127v8.0736028z","key":0}),React.createElement("path",{"d":"m0 8h5v17h-5z","key":1}),React.createElement("path",{"d":"m3 0c-1.65614157 0-3 1.33759282-3 2.98601278s1.34385843 3.01398722 3 3.01398722 3-1.36556726 3-3.01398722c-.00104094-1.64841996-1.34489938-2.98601278-3-2.98601278z","key":2})]);
}

LinkedinIcon.defaultProps = {"height":"25","viewBox":"0 0 25 25","width":"25"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
